import React, { forwardRef } from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export const WorkflowNavIcon = forwardRef(function WorkflowNavIcon(
  props: SimpleIconInterface,
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  const { fill = '#FFFFFF', ...rest } = props;

  return (
    <SimpleIcon ref={ref} viewBoxDimensions="0 0 24 24" {...rest}>
      <path
        d="M10.2 6.3L6.3 10.2M7 12C7 13.3807 5.88071 14.5 4.5 14.5C3.11929 14.5 2 13.3807 2 12C2 10.6193 3.11929 9.5 4.5 9.5C5.88071 9.5 7 10.6193 7 12ZM7 12H17M17 12C17 13.3807 18.1193 14.5 19.5 14.5C20.8807 14.5 22 13.3807 22 12C22 10.6193 20.8807 9.5 19.5 9.5C18.1193 9.5 17 10.6193 17 12ZM13.8 17.7L17.7 13.8M14.5 4.5C14.5 5.88071 13.3807 7 12 7C10.6193 7 9.5 5.88071 9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5ZM14.5 19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5C9.5 18.1193 10.6193 17 12 17C13.3807 17 14.5 18.1193 14.5 19.5Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
});
